import { render, staticRenderFns } from "./DropFile.vue?vue&type=template&id=659f6078&scoped=true&"
import script from "./DropFile.vue?vue&type=script&lang=js&"
export * from "./DropFile.vue?vue&type=script&lang=js&"
import style0 from "@/assets/dropfile.css?vue&type=style&index=0&id=659f6078&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659f6078",
  null
  
)

export default component.exports